import { render, staticRenderFns } from "./MtsTebligatGonderIslemDetayView.vue?vue&type=template&id=79922dc6&scoped=true"
import script from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79922dc6",
  null
  
)

export default component.exports